import React, { ReactElement } from 'react';
import classNames from 'classnames';

import styles from './ConfirmationModal.module.scss';

export const STATIC_CONFIRMATION_MODAL_CLASS = 'general-confirmation-modal';

export type RenderActions = (onClose: () => void) => ReactElement;

export interface ConfirmationModalProps {
  description: string;
  title: string;
  titleClassName?: string;
  renderActions?: RenderActions;
  actionsLayout?: 'column' | 'row';
}

// injected by modals manager
export interface InjectedProps {
  onClose: () => void;
}

export const ConfirmationModal = (props: ConfirmationModalProps & InjectedProps): ReactElement => {
  const {
    description,
    title,
    titleClassName,
    renderActions,
    actionsLayout = 'row',
    onClose
  } = props;

  return (
    <div className={classNames(styles.container, STATIC_CONFIRMATION_MODAL_CLASS)}>
      <div className={classNames(styles.title, titleClassName)}>{title}</div>
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
      <div
        className={classNames(styles.actions, {
          [styles.column]: actionsLayout === 'column'
        })}
      >
        {renderActions && renderActions(onClose)}
      </div>
    </div>
  );
};
